import { Controller } from "@hotwired/stimulus";
import Masonry from "masonry-layout/masonry";
import imagesLoaded from "imagesloaded/imagesloaded";

/*
 * Masonry
 *
 * Add data-controller="masonry" to a row
 *
 * @see {https://getbootstrap.com/docs/5.3/examples/masonry/}
 * @see {templates/macros/masonry_item.html}
 */
export default class extends Controller {
  connect() {
    const itemSelector = ".col";
    const percentPosition = true;
    const horizontalOrder = true;

    new imagesLoaded(this.element, () => {
      new Masonry(this.element, {
        itemSelector,
        percentPosition,
        horizontalOrder,
      });
    });
  }
}
